import { numToOrdinalSuffix } from '@/utils/strings';
import createId from '@/components/widget/Form/Question/createId'; // Create a new question object based on the question
// type with label related to the question count

const createQuestion = (questionType, questionsCount) => {
  const question = {
    id: createId(),
    layout: 'text',
    // "Input" default
    valueType: 'string',
    // "Input" default
    defaultValue: '',
    heading: `${numToOrdinalSuffix(questionsCount)} Question`,
    selections: '' // Blank non-functional question

  };

  if (questionType === 'select') {
    question.layout = 'select';
  } else if (questionType === 'radioButtons') {
    question.layout = 'radioButtons';
  } else if (questionType === 'radio') {
    question.layout = 'radio';
  } else if (questionType === 'checkbox') {
    question.layout = 'checkbox';
    question.valueType = 'boolean';
    question.checkedValue = true;
    question.uncheckedValue = false;
    delete question.defaultValue;
  } else if (questionType === 'slider') {
    question.layout = 'slider';
    question.valueType = 'integer';
    question.maximumValue = 100; // required

    question.minimumValue = 0; // required

    question.step = 1;
  } else if (questionType === 'duration') {
    question.layout = 'duration';
    question.valueType = 'integer';
  } else if (questionType === 'hidden') {
    question.layout = 'hidden';
  }

  return question;
};

export default createQuestion;